<template>
  <div class="sentences">
    <div
      class="sentence-group"
      v-for="(scenarioGroup, scenarioGroupNumber, scenarioGroupIndex) in sentenceList.scenarioGroups"
      :key="scenarioGroupNumber"
    >
      <div
        @click="setActivePath(scenarioGroupNumber, scenarioGroupIndex, scenarioGroup)"
        :class="{
          'active-dropzone-sentence': activeDropzone === scenarioGroupIndex && draggingElementIsSentence,
          'active-dropzone-scenario': activeDropzone === scenarioGroupIndex && draggingElementIsScenario
        }"
        class="sentence-group-header d-flex align-items-center"
        @drop="handleDropScenarioGroup($event, scenarioGroup, scenarioGroupNumber, sentenceList.id, scenarioGroupIndex)"
        @dragover.prevent
        @dragenter.prevent="activeDropzone = scenarioGroupIndex"
        @dragend.prevent="handleDragScenarioGroupEnd()"
        @dragleave.prevent="activeDropzone = false"
        :draggable="activeDragHandle"
        @dragstart="handleDragScenarioGroup($event, scenarioGroup, scenarioGroupNumber, scenarioGroupIndex)"
        @mouseenter="showDragDots = scenarioGroupIndex"
        @mouseleave="showDragDots = null"
      >
        <div class="line-number">
          {{
            visiblePath.length == 0 ? scenarioGroupIndex + 1 : visiblePath.concat([scenarioGroupIndex + 1]).join(".")
          }}
        </div>
        <span class="d-flex flex-grow-1" style="position: relative;">
          <span class="toggle-collapse" v-if="checkSentenceType(scenarioGroup[0].sentenceType)">
            <img
              :src="
                (inActivePath && collapsed[scenarioGroupIndex]) ||
                (!unlinkTemplateSection && collapsed[scenarioGroupIndex])
                  ? require('@/assets/svg/chevronRightEditor.svg')
                  : require('@/assets/svg/chevronDown.svg')
              "
              class="caret"
            />
          </span>
          <div class="break-image" v-if="scenarioGroup[0].sentenceType == 'Linebreak'">
            <img src="@/assets/svg/line-break.svg" />
          </div>
          <div class="break-image" v-if="scenarioGroup[0].sentenceType == 'Sectionbreak'">
            <img src="@/assets/svg/section-break.svg" />
          </div>
          <div class="new-paragraph-image" v-if="scenarioGroup[0].sentenceType == 'NewParagraph'">
            <i class="fa-light fa-paragraph"></i>
          </div>
          <span style="margin-right:2px;">
            <span> {{getSentenceTypePrettyName(scenarioGroup[0].sentenceType)}} </span>
            <span v-if='["Table", "UnorderedList", "OrderedList", "NewParagraph", "Linebreak", "Sectionbreak"].includes(scenarioGroup[0].sentenceType)'  class="text-xs">
              {{`(Sentence ${scenarioGroupIndex + 1})`}}
            </span>
            <span v-else>{{ scenarioGroupIndex + 1 }}</span>
          </span>
          <span v-if="scenarioGroup[0].sentenceType == 'Linebreak'" class="spacing-linebreak"> </span>
          <span v-if="scenarioGroup[0].sentenceType == 'Sectionbreak'" class="spacing-sectionbreak"> </span>
          <span v-if="scenarioGroup[0].sentenceType == 'NewParagraph'" class="spacing-sectionbreak"> </span>
          <div class="flex-grow-1 seperator"></div>
        </span>

        <span class="actions">
          <div
            v-if="
              !isDemo &&
                (!$store.state.showingTemplateBackupInPreview && checkSentenceType(scenarioGroup[0].sentenceType))
            "
            @click="onPrioritize(scenarioGroupNumber)"
            class="action"
            :tooltip="showTooltips ? $t('sentence-list.show-priority') : ''"
            tooltip-placement="left"
          >
            <i class="fa-light fa-sort-numeric-down"></i>
          </div>

          <div
            v-if="!isDemo"
            class="action"
            :tooltip="showTooltips ? $t('duplicate-below') : ''"
            tooltip-placement="left"
            @click.stop="onCloneScenarioGroupAfter(scenarioGroupNumber)"
          >
            <i class="fa-light fa-clone"></i>
          </div>

          <dropdown
            ref="dropdownPlus"
            left
            class="action"
            :tooltip="showTooltips ? $t('sentence.add-new') : ''"
            tooltip-placement="left"
            :darkBackground="true"
            :disabled="isDemo"
          >
            <div @click="handleAction($event, 'createNew')" class="icon-wrapper" slot="toggle" ref="dropdown">
              <i class="fa-light fa-plus"></i>
            </div>
            <sentence-list-add-elements-list
              :scenarioGroupNumber="parseInt(scenarioGroupNumber)"
              :sentence="scenarioGroup[0]"
              @on-create-scenariogroup-before="
                (sentenceType) => onCreateScenarioGroupBefore(scenarioGroupNumber, sentenceType)
              "
              @on-create-scenariogroup-after="
                (sentenceType) => onCreateScenarioGroupAfter(scenarioGroupNumber, sentenceType)
              "
              @on-create-table-element-before="
                (sentenceType) =>
                  onCreateTableTypeElementBefore(
                    scenarioGroupNumber,
                    sentenceType,
                    sentenceList.sentences[scenarioGroupNumber].tableColumnCount
                  )
              "
              @on-create-table-element-after="
                (sentenceType) =>
                  onCreateTableTypeElementAfter(
                    scenarioGroupNumber,
                    sentenceType,
                    sentenceList.sentences[scenarioGroupNumber].tableColumnCount
                  )
              "
              @on-create-table="(before) => onCreateTable(scenarioGroupNumber, 'Table', before)"
              @on-create-list="(sentenceType, before) => onCreateList(scenarioGroupNumber, sentenceType, before)"
              @on-create-list-item="
                (sentenceType, before) => onCreateListItem(scenarioGroupNumber, sentenceType, before)
              "
              @on-add-scenario-to-group="
                (sentenceType) =>
                  onAddScenarioElementToGroup(
                    scenarioGroup,
                    scenarioGroupNumber,
                    sentenceType,
                    sentenceList.sentences[scenarioGroupNumber].tableColumnCount
                  )
              "
            />
          </dropdown>

          <div
            @click="
              handleAction($event, 'default', () => {
                onRemoveScenarioGroup(scenarioGroupNumber);
              })
            "
            class="action"
            :tooltip="showTooltips ? $t('sentence-list.delete') : ''"
            tooltip-placement="left"
          >
            <i class="fa-light fa-trash"></i>
          </div>
          <div
            v-if="!isDemo"
            class="action drag-grip"
            :class="{ active: showDragDots == scenarioGroupIndex }"
            @mousedown="activeDragHandle = true"
            @mouseleave="activeDragHandle = false"
          >
            <i class="fa-light fa-grip-dots-vertical"></i>
          </div>
        </span>
      </div>
      <!-- //inActivePath && 
				//!collapsed[scenarioGroupIndex] || 
				//unlinkTemplateSection && 
				//!collapsed[scenarioGroupIndex]" -->

      <div
        v-if="
          checkSentenceType(scenarioGroup[0].sentenceType) &&
            (inActivePath || unlinkTemplateSection) &&
            !collapsed[scenarioGroupIndex]
        "
        class="flex-grow-1 sentence-group-content"
      >
        <sentence
          v-for="(s, scenarioIndex) in scenarioGroup"
          :key="s.id"
          :depth="depth || 0"
          :visible-path="visiblePath.concat([scenarioGroupIndex + 1]).concat(true ? [scenarioIndex + 1] : [])"
          :active-path="activePath"
          :sentence="s"
          :style="{ 'margin-left': true ? '35px' : 0 }"
          :has-sibling-scenarios="true"
          :priority="s.priority"
          :showPriority="showPriority"
          :sentenceNumber="SentenceNumberProritize"
          :unlinkTemplateSection="unlinkTemplateSection"
          :showRawHTML="showRawHTML"
          :scenarioIndex="scenarioIndex"
          :draggingIndex="draggingIndex"
          :draggingPriority="draggingPriority"
          :templateSectionCopy="templateSectionCopy"
          :scenarioGroupPriorities="scenarioGroup.map((g) => g.priority)"
          :scenarioGroupNumber="scenarioGroupNumber"
          @bump-priority-down="(scenarioGroupNumber, sentence) => unlinkScenario(scenarioGroupNumber, sentence)"
          @start-drag-sentence="
            ($event, sentence, header, collapseState) =>
              handleDragScenario(
                $event,
                sentence,
                sentenceList,
                scenarioIndex,
                scenarioGroupNumber,
                collapseState,
                header
              )
          "
          @drop-sentence="
            ($event, sentence) => handleDropScenario($event, sentence, scenarioIndex, scenarioGroupNumber)
          "
          @add-scenario-above="onAddScenarioAbove(s)"
          @add-scenario-below="onAddScenarioBelow(s)"
          @add-table-below="onCreateTable(scenarioGroupNumber, 'Table', false, true)"
          @add-row-below="onAddRowToTable(s)"
          @add-cell-below="onAddCellToTable(s)"
          @add-list-below="onAddListBelow(s)"
          @add-list-item-below="onAddListItemBelow(s)"
          @clone-scenario-below="onCloneScenarioBelow(s)"
          @add-sibling-variant="onAddSentenceBelow(s)"
          @refresh-list="refreshList()"
          @remove="onRemoveScenario(s)"
          @change="onSentenceChange(s, s.id)"
          @add-sentence="onAddSentenceBelow(s)"
        />
        <!-- @drop-sentence="handleDropScenario()" -->
        <!-- <div class="add-sentence" @click="sentenceList.addNewSentence()">+ Tilføj sætning</div> -->
      </div>
    </div>
    <div
      class="bottom-drop-zone"
      :class="{ 'bottom-drop-zone-active': bottomDropzone && draggingElementIsSentence }"
      @drop="
        handleDropScenarioGroupInBottom($event, sentenceList.id, sentenceList.sentences[0].sentenceType),
          (bottomDropzone = false)
      "
      @dragover.prevent
      @dragenter.prevent="bottomDropzone = true"
      @dragend.prevent="bottomDropzone = false"
      @dragleave.prevent="bottomDropzone = false"
    >
      <!-- Bottom dropzone -->
    </div>
  </div>
</template>

<script>
// import { groupBy, uniqueId, orderBy } from "lodash";
import Sentence from "@/components/Sentence";
import Dropdown from "@/components/Dropdown";
import SentenceListAddElementsList from "@/components/SentenceListAddElementsList";
import ConfirmModal from "@/components/modals/ConfirmModal";
import CreateTableModal from "@/components/modals/CreateTableModal";
import EventBus from "@/assets/js/eventBus.js";
import ContextMenu from "@/components/ContextMenu";
import { editorMixin } from "@/assets/js/editorMixin.js";
export default {
  name: "sentence-list",
  mixins: [editorMixin],
  props: {
    sentenceList: {
      type: Object,
      required: true
    },
    depth: {
      type: Number
    },
    visiblePath: {
      type: Array,
      required: true
    },
    activePath: {
      type: Array,
      required: true
    },
    unlinkTemplateSection: {
      type: Boolean
    },
    templateSectionCopy: Object,
    showRawHTML: Boolean
  },
  data() {
    return {
      collapsed: {},
      showPriority: false,
      SentenceNumberProritize: null,
      hoverMenuSentence: false,
      hoverMenuSinglebreak: false,
      hoverMenuDoublebreak: false,
      hoverMenuTableType: false,
      hoverMenuTable: false,
      activeDropzone: false,
      activeDragHandle: false,
      bottomDropzone: null,
      draggingIndex: null,
      draggingPriority: null,
      showDragDots: false
    };
  },
  computed: {
    // visiblePath () {
    // 	return (this.path || []).map(p => p + 1)
    // },
    multipleScenarios() {
      return Object.keys(this.sentenceList.scenarioGroups).length > 1;
    },
    inActivePath() {
      return this.activePath.slice(0, this.sentenceList.path.length).toString() === this.sentenceList.path.toString();
    },
    groups() {
      return this.sentenceList.scenarioGroups;
    },
    draggingElementIsScenario() {
      return this.$store.state.draggedScenario ? true : false;
    },
    draggingElementIsSentence() {
      return this.$store.state.draggingScenarioGroup;
    },
    showTooltips() {
      return this.$store.state.showTooltips;
    },
    isDemo() {
      return this.$store.state.editorIsDemoVersion;
    }
  },
  methods: {
    checkSentenceType(sentenceType) {
      const invalidTypes = ["Sectionbreak", "Linebreak", "NewParagraph"];
      const validTypes = [
        "TableCell",
        "TableHeaderCell",
        "TableHeaderRow",
        "TableRow",
        "Table",
        "UnorderedList",
        "OrderedList",
        "ListItem",
        "Sentence",
        undefined,
        null
      ];
      return validTypes.includes(sentenceType);
    },
    tableTypeActions(sentenceType) {
      return ["TableCell", "TableHeaderCell", "TableHeaderRow", "TableRow", "Table"].includes(sentenceType);
    },
    listTypeActions(sentenceType) {
      return ["ListItem", "OrderedList", "UnorderedList"].includes(sentenceType);
    },

    nonStandardSentenceType(sentenceType) {
      return (
        this.tableTypeActions(sentenceType) ||
        this.listTypeActions(sentenceType) ||
        ["NewParagraph", "Sectionbreak", "Linebreak"].includes(sentenceType)
      );
    },

    handleDragScenarioGroup(evt, scenarioGroup, scenarioGroupNumber, scenarioGroupIndex) {
      this.$set(this.collapsed, scenarioGroupIndex, true);
      evt.stopPropagation();
      evt.dataTransfer.dropEffect = "copyMove";
      evt.dataTransfer.effectAllowed = "copyMove";

      evt.dataTransfer.setData("draggingScenarioGroupSentenceType", scenarioGroup[0].sentenceType);
      evt.dataTransfer.setData("draggingScenarioGroup", JSON.stringify(scenarioGroup));
      evt.dataTransfer.setData("draggingscenarioGroupNumber", JSON.stringify(scenarioGroupNumber));
      evt.dataTransfer.setData("draggingscenarioGroupIndex", scenarioGroupIndex);
      evt.dataTransfer.setData("draggedSentenceListId", this.sentenceList.id);

      this.$store.commit("dragScenarioGroupStarted");
    },

    handleDropScenarioGroup(evt, scenarioGroup, scenarioGroupNumber, sentenceListId, scenarioGroupIndex) {
      this.activeDropzone = false;
      evt.stopPropagation();
      this.$set(this.collapsed, parseInt(evt.dataTransfer.getData("draggingscenarioGroupIndex")), false);
      const sentenceType = evt.dataTransfer.getData("draggingScenarioGroupSentenceType");

      if (evt.dataTransfer.getData("variantId")) {
        // Avoid dropping variants into scenarioGroup
        EventBus.$emit("drag-and-drop-err", this.$t("errors.variant-to-sentence"));
      }
      if (evt.dataTransfer.getData("sentenceId")) {
        const draggingSentenceType = [undefined, "undefined"].includes(evt.dataTransfer.getData("sentenceType"))
          ? "Sentence"
          : evt.dataTransfer.getData("sentenceType");
        const destinationSentenceType =
          scenarioGroup[0].sentenceType == undefined ? "Sentence" : scenarioGroup[0].sentenceType;
        if (draggingSentenceType == destinationSentenceType) {
          // Prevent dropping scenarios into Sectionbreaks and Linebreaks
          const newPriority =
            Math.max(
              ...this.sentenceList.sentences
                .filter((s) => parseInt(s.number) == scenarioGroupNumber)
                .map((s) => s.priority)
            ) + 1;
          if (sentenceListId != evt.dataTransfer.getData("sentenceListId")) {
            // Now trying to drop the scenario into a scenariogroup in a new sentencelist
            this.moveScenarioToNewList(
              evt.dataTransfer.getData("sentenceListId"),
              evt.dataTransfer.getData("sentenceId"),
              newPriority,
              scenarioGroupNumber,
              sentenceListId,
              evt.altKey
            );
          } else {
            let movingScenario = this.sentenceList.sentences.find(
              (s) => s.id == evt.dataTransfer.getData("sentenceId")
            );
            if (evt.altKey) {
              this.sentenceList.sentences.push(movingScenario.clone());
            }
            movingScenario.priority = newPriority;
            movingScenario.number = scenarioGroupNumber;
            this.sentenceList.refreshPaths();
          }
          this.sentenceList.moveScenario();
        } else {
          //User dropped a scenario into a Sectionbreak or Linebreak. This is not allowed
          EventBus.$emit("drag-and-drop-err", "Action not allowed");
        }
      }
      if (evt.dataTransfer.getData("draggingScenarioGroup")) {
        // Dragging a scenarioGroup

        if (this.checkSentenceTypes(sentenceType, scenarioGroup[0].sentenceType))
          return this.handleDragScenarioGroupEnd();

        this.$store
          .dispatch("cloneScenarioGroup", {
            sentenceListId: evt.dataTransfer.getData("draggedSentenceListId"),
            number: JSON.parse(evt.dataTransfer.getData("draggingscenarioGroupNumber"))
          })
          .then((res) => {
            let newNumber = this.sentenceList.bumpSentencesIfNecessary(scenarioGroupNumber);
            res.forEach((scenario) => {
              scenario.number = newNumber;
              this.$store.commit("addScenarioToNewList", {
                scenario: scenario,
                newSentenceListId: sentenceListId
              });
              if (!evt.altKey) {
                this.$store.commit("removeScenario", {
                  sentenceListId: evt.dataTransfer.getData("draggedSentenceListId"),
                  sentenceId: scenario.oldId
                });
              }
            });
          });
        this.sentenceList.refreshPaths();
        this.sentenceList.moveScenario();
        EventBus.$emit("templateChange");
      }
      this.$nextTick(() => this.$set(this.collapsed, parseInt(scenarioGroupIndex), false));
    },

    handleDropScenarioGroupInBottom(evt, sentenceListId, sentenceType) {
      if (this.draggingElementIsSentence) {
        if (this.checkSentenceTypes(evt.dataTransfer.getData("draggingScenarioGroupSentenceType"), sentenceType))
          return this.handleDragScenarioGroupEnd();
        evt.stopPropagation();
        this.$store
          .dispatch("cloneScenarioGroup", {
            sentenceListId: evt.dataTransfer.getData("draggedSentenceListId"),
            number: JSON.parse(evt.dataTransfer.getData("draggingscenarioGroupNumber"))
          })
          .then((res) => {
            let newNumber = Math.max(...this.sentenceList.sentences.map((s) => s.number || 0)) + 1;
            res.forEach((scenario) => {
              scenario.number = newNumber;
              this.$store.commit("addScenarioToNewList", {
                scenario: scenario,
                newSentenceListId: sentenceListId
              });
              if (!evt.altKey) {
                this.$store.commit("removeScenario", {
                  sentenceListId: evt.dataTransfer.getData("draggedSentenceListId"),
                  sentenceId: scenario.oldId
                });
              }
            });
          });
        this.$nextTick(() => {
          this.$set(this.collapsed, parseInt(evt.dataTransfer.getData("draggingscenarioGroupIndex")), false);
        });
        EventBus.$emit("templateChange");
      }
    },

    checkSentenceTypes(draggedType, dropZoneType) {
      const sentenceTypes = [undefined, null, "undefined"];
      if (sentenceTypes.includes(draggedType)) draggedType = "Sentence";
      if (sentenceTypes.includes(dropZoneType)) dropZoneType = "Sentence";
      if (
        draggedType != dropZoneType &&
        ((draggedType.includes("Cell") && !dropZoneType.includes("Cell")) ||
          (dropZoneType.includes("Cell") && !draggedType.includes("Cell")) ||
          (draggedType.includes("Row") && !dropZoneType.includes("Row")) ||
          (dropZoneType.includes("Row") && !draggedType.includes("Row")) ||
          (draggedType.includes("ListItem") && !dropZoneType.includes("List")) ||
          (dropZoneType.includes("List") && !draggedType.includes("List")))
      ) {
        EventBus.$emit("drag-and-drop-err", "You can not drop this element here");
        return true;
      }
    },

    handleDragScenarioGroupEnd() {
      this.activeDropzone = false;
      this.$store.commit("dragScenarioGroupEnded");
    },

    handleDragScenario(evt, sentence, sentenceList, scenarioIndex, scenarioGroupNumber, collapseState, header) {
      evt.stopPropagation();
      if (!evt.dataTransfer.getData("variantId")) {
        evt.dataTransfer.dropEffect = "copyMove";
        evt.dataTransfer.effectAllowed = "copyMove";
        // evt.dataTransfer.setDragImage(header, header.offsetWidth*2, 10);
        evt.dataTransfer.setData("sentenceId", sentence.id);
        evt.dataTransfer.setData("sentenceType", sentence.sentenceType);
        evt.dataTransfer.setData("sentenceIndex", scenarioIndex);
        evt.dataTransfer.setData("sentenceListId", sentenceList.id);
        evt.dataTransfer.setData("sentenceGroupNumber", scenarioGroupNumber);
        evt.dataTransfer.setData("collapseState", collapseState);
        this.draggingIndex = scenarioIndex;
        this.draggingPriority = sentence.priority;

        this.$store.commit("dragScenario", { draggedScenario: sentence });
      }
    },

    handleDropScenario(evt, sentence, scenarioIndex, scenarioGroupNumber) {
      evt.stopPropagation();
      if (evt.dataTransfer.getData("sentenceId")) {
        //Dropping a scenario
        const sentenceId = evt.dataTransfer.getData("sentenceId");
        const sentenceType = evt.dataTransfer.getData("sentenceType");
        const sentenceIndex = evt.dataTransfer.getData("sentenceIndex");
        const sentenceListId = evt.dataTransfer.getData("sentenceListId");
        const sentenceGroupNumber = evt.dataTransfer.getData("sentenceGroupNumber");
        const movingDown = scenarioIndex > parseInt(sentenceIndex);
        const newPriority = this.sentenceList.prioritizeScenariosInSentence(
          scenarioGroupNumber,
          sentence.priority,
          movingDown
        );

        if (sentenceType != sentence.sentenceType) {
          return this.$store.commit("dragScenarioEnded");
        }

        if (sentenceListId === this.sentenceList.id) {
          // Moving a scenario around in the same sentencelist
          let movingScenario = this.sentenceList.sentences.find((s) => s.id == sentenceId);
          if (evt.altKey) {
            this.sentenceList.sentences.push(movingScenario.clone());
          }
          movingScenario.priority = newPriority;
          movingScenario.number = scenarioGroupNumber;

          // Set active path to new destination
          this.sentenceList.moveScenario();
          this.$store.commit("refreshPathsInSection");
          this.$store.dispatch("setActivePath", this.sentenceList.getById(evt.dataTransfer.getData("sentenceId")).path);
        } else if (sentenceListId !== this.sentenceList.id) {
          // Moving a scenario into another sentenceList
          this.moveScenarioToNewList(
            sentenceListId,
            sentenceId,
            newPriority,
            scenarioGroupNumber,
            this.sentenceList.id,
            evt.altKey
          );
          this.sentenceList.moveScenario();
          this.$store.commit("refreshPathsInSection");
        }
      } else {
        //Is a sentencegroup - emit method to parent component (sentenceEditPopover)
        console.log("Sentencegroup - dont drop here");
      }
      this.$store.commit("dragScenarioEnded");
      EventBus.$emit("templateChange");
    },

    moveScenarioToNewList(
      sentenceListId,
      sentenceId,
      newPriority,
      scenarioGroupNumber,
      newSentenceListId,
      shouldClone
    ) {
      this.$store
        .dispatch("cloneScenario", {
          sentenceListId: sentenceListId,
          sentenceId: sentenceId
        })
        .then((res) => {
          res.priority = newPriority;
          res.number = scenarioGroupNumber;
          this.$store.commit("addScenarioToNewList", {
            scenario: res,
            newSentenceListId: newSentenceListId
          });
          if (!shouldClone) {
            this.$store.commit("removeScenario", {
              sentenceListId: sentenceListId,
              sentenceId: sentenceId
            });
          }
          this.sentenceList.moveScenario();
        });
    },

    onPrioritize(scenarioGroupNumber) {
      event.stopPropagation();
      if (this.SentenceNumberProritize && scenarioGroupNumber != this.SentenceNumberProritize) {
        this.SentenceNumberProritize = scenarioGroupNumber;
        this.showPriority = true;
      } else {
        this.SentenceNumberProritize = scenarioGroupNumber;
        this.showPriority = !this.showPriority;
      }
    },

    setActivePath(scenarioGroupNumber, scenarioGroupIndex, scenarioGroup) {
      if (
        scenarioGroup &&
        (scenarioGroup[0].sentenceType == "Linebreak" ||
          scenarioGroup[0].sentenceType == "Sectionbreak" ||
          scenarioGroup[0].sentenceType == "NewParagraph")
      ) {
        // Dont do anything
      } else {
        if (this.activePath.toString() === this.sentenceList.path.toString())
          this.$set(
            this.collapsed,
            scenarioGroupIndex,
            !this.collapsed[scenarioGroupIndex] // Or [scenarioGroupIndex] ??
          );
        else this.$store.dispatch("setActivePath", this.sentenceList.path);
      }
    },

    onCreateScenarioGroupBefore(scenarioGroupNumber, sentenceType) {
      let firstScenarioInNewGroup = this.sentenceList.createScenarioGroupBefore(scenarioGroupNumber, sentenceType);
      this.$store.dispatch("setActivePath", firstScenarioInNewGroup.path);
      EventBus.$emit("templateChange");
    },

    onCreateScenarioGroupAfter(scenarioGroupNumber, sentenceType) {
      let firstScenarioInNewGroup = this.sentenceList.createScenarioGroupAfter(scenarioGroupNumber, sentenceType);
      this.$store.dispatch("setActivePath", firstScenarioInNewGroup.path);
      EventBus.$emit("templateChange");
    },

    onCreateTableTypeElementBefore(scenarioGroupNumber, sentenceType, tableColumnCount) {
      let newElement;
      if (["TableRow", "TableHeaderRow"].includes(sentenceType)) {
        newElement = this.sentenceList.addNewRowBefore(scenarioGroupNumber, sentenceType, parseInt(tableColumnCount));
      } else if (["TableCell", "TableHeaderCell"].includes(sentenceType)) {
        newElement = this.sentenceList.addNewCellBefore(scenarioGroupNumber, sentenceType, parseInt(tableColumnCount));
      }
      this.$store.dispatch("setActivePath", newElement.path);
      EventBus.$emit("templateChange");
    },

    onCreateTableTypeElementAfter(scenarioGroupNumber, sentenceType, tableColumnCount) {
      let newElement;
      if (["TableRow", "TableHeaderRow"].includes(sentenceType)) {
        newElement = this.sentenceList.addNewRowAfter(scenarioGroupNumber, sentenceType, parseInt(tableColumnCount));
      } else if (["TableCell", "TableHeaderCell"].includes(sentenceType)) {
        newElement = this.sentenceList.addNewCellAfter(scenarioGroupNumber, sentenceType, parseInt(tableColumnCount));
      }

      this.$store.dispatch("setActivePath", newElement.path);
      EventBus.$emit("templateChange");
    },

    onCreateTable(scenarioGroupNumber, sentenceType, before, inSentence, priority) {
      this.$modal.show(
        CreateTableModal,
        {
          onCreate: (columns, rows, applyTableHeadRow, applyTableHeadColumn) => {
            let tableBase;
            if (inSentence) {
              tableBase = this.sentenceList.createTableBase(
                scenarioGroupNumber,
                sentenceType,
                columns,
                rows,
                applyTableHeadRow,
                applyTableHeadColumn,
                priority
              );
            } else if (before) {
              tableBase = this.sentenceList.createTableBefore(
                scenarioGroupNumber,
                sentenceType,
                columns,
                rows,
                applyTableHeadRow,
                applyTableHeadColumn
              );
            } else
              tableBase = this.sentenceList.createTableAfter(
                scenarioGroupNumber,
                sentenceType,
                columns,
                rows,
                applyTableHeadRow,
                applyTableHeadColumn
              );
            this.$store.dispatch("setActivePath", tableBase.path);
            this.sentenceList.refreshPaths();
            EventBus.$emit("templateChange");
          }
        },
        { width: 350, height: "auto", adaptive: true }
      );
    },

    onAddRowToTable(s) {
      const newRow = this.sentenceList.addNewRow(s.number, s.priority, s.sentenceType, parseInt(s.tableColumnCount));
    },

    onAddCellToTable(s) {
      const newCell = this.sentenceList.addNewCell(s.number, s.priority, s.sentenceType, parseInt(s.tableColumnCount));
    },

    onCreateList(number, sentenceType, before) {
      const tableBase = before
        ? this.sentenceList.createListBefore(number, sentenceType)
        : this.sentenceList.createListAfter(number, sentenceType);
      this.sentenceList.refreshPaths();
      EventBus.$emit("templateChange");
    },

    onCreateListItem(number, sentenceType, before) {
      const listItem = before
        ? this.sentenceList.createScenarioGroupBefore(number, sentenceType)
        : this.sentenceList.createScenarioGroupAfter(number, sentenceType);
      this.sentenceList.refreshPaths();
      EventBus.$emit("templateChange");
    },

    onAddListBelow(s) {
      const newList = this.sentenceList.createList(s.number, s.sentenceType);
    },

    onAddListItemBelow(s) {
      const newListItem = this.sentenceList.addSentence(s.number, parseInt(s.priority + 1), s.sentenceType);
    },

    onCloneScenarioGroupAfter(scenarioGroupNumber) {
      this.sentenceList.cloneScenarioGroupAfter(scenarioGroupNumber);
      EventBus.$emit("templateChange");
    },

    onRemoveScenarioGroup(scenarioGroupNumber) {
      this.$modal.show(
        ConfirmModal,
        {
          title: this.$t("sentence-list.del-sentence-title"),
          description: this.$t("sentence-list.del-sentence-desc"),
          confirmButtonText: this.$t("sentence-list.delete-btn"),
          onConfirm: (result) => {
            this.sentenceList.removeScenarioGroupByNumber(scenarioGroupNumber);
            EventBus.$emit("templateChange");
          }
        },
        { width: 350, height: "auto", adaptive: true }
      );
    },

    // add a sentence with the same number and next priority (shift lower priorities one)
    onAddSentenceBelow(sentence) {
      this.sentenceList.createSentenceAfter(sentence);
      EventBus.$emit("templateChange");
    },

    // add a scenario above the provided one, meaning one with a lower priority number than the current.
    onAddScenarioAbove(scenario) {
      let addedScenario = this.sentenceList.createScenarioBefore(scenario.number, scenario.priority);
      this.$store.dispatch("setActivePath", addedScenario.path);
      this.$nextTick(() => addedScenario.variantList.variants[0].edit());
      EventBus.$emit("templateChange");
    },

    // add a scenario below the provided one, meaning one with a higher priority number than the current.
    onAddScenarioBelow(scenario) {
      let addedScenario = this.sentenceList.createScenarioAfter(scenario.number, scenario.priority);
      this.$store.dispatch("setActivePath", addedScenario.path);
      this.$nextTick(() => addedScenario.variantList.variants[0].edit());
      EventBus.$emit("templateChange");
    },

    onCloneScenarioBelow(scenario) {
      this.sentenceList.cloneScenarioAfter(scenario);
      EventBus.$emit("templateChange");
    },

    onAddScenario(scenarioGroup, priority) {
      let addedScenario = this.sentenceList.addSentence(scenarioGroup[0].number, priority);

      this.$store.dispatch("setActivePath", addedScenario.path);
      this.$nextTick(() => addedScenario.variantList.variants[0].edit());
      EventBus.$emit("templateChange");
    },

    onAddScenarioElementToGroup(scenarioGroup, scenarioGroupNumber, sentenceType, columnCount) {
      console.log(scenarioGroupNumber);
      console.log(sentenceType);
      const priority = Math.max(...scenarioGroup.map((s) => s.priority)) + 1;
      if (sentenceType == "Table") {
        this.onCreateTable(scenarioGroupNumber, sentenceType, false, true, priority);
      } else if (["OrderedList", "UnorderedList"].includes(sentenceType)) {
        console.log("ADd llist");
        this.sentenceList.createList(scenarioGroupNumber, sentenceType, priority);
      } else if ([undefined, null, "Sentence"].includes(sentenceType)) {
        this.onAddScenario(scenarioGroup, priority);
      } else if (["TableRow", "TableHeaderRow"].includes(sentenceType)) {
        this.onAddRowToTable({
          number: scenarioGroupNumber,
          priority: priority,
          sentenceType: sentenceType,
          tableColumnCount: columnCount
        });
      } else if (["TableCell", "TableHeaderCell"].includes(sentenceType)) {
        this.onAddCellToTable({
          number: scenarioGroupNumber,
          priority: priority,
          sentenceType: sentenceType,
          tableColumnCount: columnCount
        });
      } else {
        this.sentenceList.addSentence(scenarioGroupNumber, priority, sentenceType);
      }
    },

    onRemoveScenario(scenario) {
      this.$modal.show(
        ConfirmModal,
        {
          title: this.$t("sentence-list.del-scenario-title"),
          description: this.$t("sentence-list.del-scenario-desc"),
          confirmButtonText: this.$t("sentence-list.delete-btn"),
          onConfirm: (result) => {
            this.sentenceList.removeById(scenario.id);
            EventBus.$emit("templateChange");
          }
        },
        { width: 350, height: "auto", adaptive: true }
      );
    },

    onAddNewCondition(conditionList, scenarioGroupNumber) {
      this.setActivePath(scenarioGroupNumber);
      conditionList.addNewCondition(-1);
      EventBus.$emit("templateChange");
    },

    onAddVariant(variantList, scenarioGroupNumber) {
      this.setActivePath(scenarioGroupNumber);
      variantList.add("").edit();
      EventBus.$emit("templateChange");
    },

    refreshList() {
      this.sentenceList.moveScenario();
      this.sentenceList.onUpdated();
    },
    unlinkScenario(scenarioGroupNumber, sentence) {
      this.$set(
        sentence,
        "priority",
        this.sentenceList.prioritizeScenariosInSentence(scenarioGroupNumber, sentence.priority, true)
      );
      this.sentenceList.moveScenario();
      EventBus.$emit("templateChange");
    }
  },
  created() {
    if (this.sentenceList.sentences.length == 0) {
      // Empty section, auto add a sentence to get started.
      this.$emit("empty-section");
    }
  },

  components: {
    Sentence,
    Dropdown,
    ContextMenu,
    SentenceListAddElementsList
  }
};
</script>

<style lang="less">
.line-number {
  position: absolute;
  left: 0;
  font-size: 12px;
  line-height: 24px;
  padding-left: 15px;
  color: #8f979c;
  overflow-y: auto;
  width: 70px;
}
.grip-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  height: 100%;
}
.sentences {
  .active-dropzone-scenario {
    background-color: #6e757a;
    transition: 0.1s;
  }
  .sentence-group .active-dropzone-sentence {
    background-color: none;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      height: 50px;
      background-color: rgba(110, 117, 122, 0.123);
      border: thin dashed #8f979c;
      width: calc(100% - 20px);
    }
    padding-top: 50px;
    .line-number {
      opacity: 0;
    }
  }
  .bottom-drop-zone {
    padding: 10px 0;
  }
  .bottom-drop-zone-active {
    padding: 20px 0;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      height: 50px;
      background-color: rgba(110, 117, 122, 0.123);
      border: thin dashed #8f979c;
      width: calc(100% - 20px);
    }
  }
}
.sentence-group {
  // &:hover {
  // 	background: rgba(176, 179, 176, 0.144)
  // }
  & + .sentence-group {
    margin-top: 8px;
  }
  .sentence-group-content {
    border-left: 1px solid #8f979c;
    margin-left: 22px;
  }
  .sentence-group-header {
    border-radius: 20px 0 0 20px;
    font-weight: 900;
    line-height: 24px;
    display: flex;
    margin-top: 8px;
    padding: 8px 10px;
    .toggle-collapse {
      padding-left: 8px;
      padding-right: 8px;
    }
    .actions {
      display: flex;
      // flex-direction: row-reverse;
      justify-content: center;
      white-space: nowrap;
      visibility: hidden;
      padding: 0 5px;
      align-items: center;

      .dropdown {
        padding: 0 15px 0 0;
        .toggle {
          display: flex;
          justify-content: center;
        }
        &.second-drop {
          margin-right: 10px;
          padding: 0;
        }
      }
      .action {
        margin: 2px 8px 2px 0;
        padding: 4px 6px;
        width: 24px;
        height: 24px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon-wrapper {
          height: 14px;
          align-items: center;
          display: flex;
        }
        &:hover {
          background-color: var(--charcoal);
          border-radius: 100%;
        }
      }
      .break-options,
      .dropdown-dots {
        margin-right: 10px;
      }
      .drag-grip {
        padding: 4px 12px;
      }
    }
    &:hover {
      background: rgba(176, 179, 176, 0.144);
      .actions {
        visibility: visible;
      }
    }

    .submenu {
      position: relative;
      &.create-sentence {
        min-width: 122px;
      }
    }
  }

  .spacing-sectionbreak {
    + .seperator {
      margin-left: 12px;
      height: 1px;
      width: auto;
      align-self: center;
      position: relative;
      margin-bottom: 4px;
      &::after {
        content: "";
        position: absolute;

        height: 8px;
        width: 100%;
        border-top: 1px solid #8f979c;
        border-bottom: 1px solid #8f979c;
      }
    }
  }
  .spacing-linebreak {
    + .seperator {
      margin-left: 12px;
      height: 1px;
      border-bottom: 1px solid #8f979c;
      // background: #8f979c;
      width: auto;
      align-self: center;
    }
  }
  .break-image img {
    height: 15px;
    padding: 0 5px;
    pointer-events: none;
  }
  .new-paragraph-image {
    width: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .caret {
    pointer-events: none;
  }
  .context-submenu {
    position: absolute;
    right: 0%;
    top: 0px;
    transform: translateX(-150%);
  }
  .spacing-linebreak img,
  .spacing-sectionbreak img {
    height: 14px;
  }
}
</style>
